import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BikeScooterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bike_scooter"}/>
}
